import React, { useState } from "react";
import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogContent,
  DialogTitle,
  MenuItem,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { Notice } from "./RouteWorkspaceHeader";
export function StepNotices({
  blockers,
  onNavigate,
  title = "Bloqueos en este paso",
}: {
  blockers: Notice[];
  onNavigate: (section: string, notice?: Notice) => void;
  title?: string;
}) {
  if (!blockers.length) return null;
  return (
    <Box
      id="route-blockers"
      sx={{
        border: "1px solid #fac7c2",
        borderRadius: 2,
        overflow: "hidden",
        mb: 3,
        bgcolor: "white",
      }}
    >
      <Typography
        fontWeight={700}
        color="error.main"
        sx={{ bgcolor: "#fff0ee", px: 2.5, py: 1.5 }}
      >
        {blockers.length} · {title}
      </Typography>
      {blockers.map((notice, index) => (
        <Stack
          key={index}
          direction={{ xs: "column", sm: "row" }}
          alignItems={{ xs: "stretch", sm: "center" }}
          justifyContent="space-between"
          gap={2}
          sx={{ px: 2.5, py: 1, borderTop: "1px solid #f9dad6" }}
        >
          <Typography variant="body2">● &nbsp; {notice.text}</Typography>
          <Button onClick={() => onNavigate(notice.target, notice)}>{/capacidad|carga/i.test(notice.text) ? 'Registrar capacidad y carga' : /disponibilidad/i.test(notice.text) ? 'Confirmar disponibilidad' : /máquina/i.test(notice.text) ? 'Revisar decisiones' : 'Resolver'}</Button>
        </Stack>
      ))}
    </Box>
  );
}
export default function RouteFocusHeader({
  selected,
  proposals,
  onSelect,
  onBack,
  onNavigate,
  status,
  date,
  blockers,
  warnings,
  busy,
  section,
}: any) {
  const [notice, setNotice] = useState("");
  return (
    <Stack direction="row" alignItems="center" flexWrap="wrap" gap={1.5}>
      <Button
        variant="outlined"
        aria-label="Volver a las rutas"
        onClick={onBack}
        disabled={busy}
        sx={{ minWidth: 42 }}
      >
        ‹
      </Button>
      <TextField
        select
        label="Ruta"
        value={selected._id}
        onChange={(event) =>
          onSelect(
            proposals.find(
              (proposal: any) => proposal._id === event.target.value
            )
          )
        }
        disabled={busy}
        sx={{ minWidth: 0, width: { xs: "calc(100% - 64px)", sm: 220 }, "& .MuiSelect-select": { fontWeight: 700 } }}
      >
        {proposals.map((proposal: any) => (
          <MenuItem key={proposal._id} value={proposal._id}>
            {proposal.route_name}
          </MenuItem>
        ))}
      </TextField>
      <Chip variant="outlined" label={status} />
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          flex: { xs: "1 0 100%", xl: "1 1 300px" },
          order: { xs: 2, xl: 0 },
          minWidth: 0,
        }}
      >
        Servicio {date} ·{" "}
        {["driver", "truck", "warehouse"]
          .map(
            (key) => selected.resources?.[key]?.name || "Nombre sin confirmar"
          )
          .join(" · ")}
      </Typography>
      <Button
        onClick={() => setNotice("blockers")}
        sx={{ bgcolor: "#ffeded", color: "error.main" }}
      >
        {blockers.length} bloqueos
      </Button>
      <Button
        onClick={() => setNotice("warnings")}
        sx={{ bgcolor: "#fff4e1", color: "warning.main" }}
      >
        {warnings.length} {warnings.length === 1 ? "aviso" : "avisos"}
      </Button>
      {selected.daily_policy?.mode === 'daily' && section !== 'route-machines' && <Button onClick={() => onNavigate("route-machines")}>Ver máquinas</Button>}
      <Button aria-pressed={section === 'route-map'} onClick={() => onNavigate("route-map")}>Mapa y orden</Button>
      <Button onClick={() => onNavigate("route-history")}>Historial</Button>
      <Button onClick={() => onNavigate("route-follow-up")}>Seguimiento</Button>
      <Dialog
        open={Boolean(notice)}
        onClose={() => setNotice("")}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>
          {notice === "blockers" ? "Bloqueos de la ruta" : "Avisos de la ruta"}
          <Button onClick={() => setNotice("")} sx={{ float: "right" }}>
            Cerrar
          </Button>
        </DialogTitle>
        <DialogContent>
          {(notice === "blockers" ? blockers : warnings).map(
            (entry: Notice, i: number) => (
              <Button
                key={i}
                sx={{ display: "block", textAlign: "left", mb: 1 }}
                onClick={() => {
                  onNavigate(entry.target);
                  setNotice("");
                }}
              >
                {entry.text}
              </Button>
            )
          )}
          {notice === "blockers" && !blockers.length && (
            <Typography>No hay bloqueos registrados.</Typography>
          )}
        </DialogContent>
      </Dialog>
    </Stack>
  );
}
